import type { IParameterSet } from '$shared/interfaces/api/IParameterSet';
import BaseModel from '$shared/models/BaseModel';
import type { ModuleEntityType } from '$shared/constants/ModuleEntityType';
import type { EntityParameterType } from '$shared/constants/EntityParameterType';

export default class ParameterSet extends BaseModel<IParameterSet> {
  declare public id: string;
  declare public supportedParameterTypes: EntityParameterType[];
  declare public requiredParameterTypes: EntityParameterType[];
  declare public isPreferred: boolean;

  constructor(data: IParameterSet) {
    super(data);
  }

  public get entityType(): ModuleEntityType | null {
    return this.response?.entityType || null;
  }

  protected override transformResponse(): void {
    this.id = this.response.id;
    this.isPreferred = this.response.isPreferred;
    this.supportedParameterTypes = this.response.supportedParameterTypes;
    this.requiredParameterTypes = this.response.requiredParameterTypes;
  }

  static getParametersByEntityType(
    parameterSets: ParameterSet[],
    entityType: ModuleEntityType
  ): ParameterSet[] {
    return parameterSets.filter((paramSet) => paramSet.entityType === entityType);
  }
}
